import type { IntakeFormsData, IntakeFormsResponse } from './procedure-api.type'

export const transformIntakeFormsResponse = (response: IntakeFormsResponse): IntakeFormsData => ({
  forms: response?.data?.forms ?? [],
  hasProfileImage: response?.data?.has_profile_image ?? true,
})
